import axios from "axios";

const url = process.env.REACT_APP_BASE_URL || "/";

export const authService = {
  adminRegistrationValidation,
  adminRegistration,
  forgotPassword,
  login,
  verifyToken,
  changePassword,
  participantLogin,
  participantForgotPassword,
  participantVerifyToken,
  participantChangePassword,
  loginAndSendOTP,
  resendLoginOTP,
  participantsloginAndSendOTP,
  participantsResendLoginOTP
};

//api call for workshop registration validation
async function adminRegistrationValidation(
  registerData,
  companyId,
  workshop_id,
  is_project=false
) {
  const api =
    is_project ? url + `/companies/${companyId}/workshops/${workshop_id}/admins/validate?is_project=${is_project}` 
               : url + `/companies/${companyId}/workshops/${workshop_id}/admins/validate`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, registerData, { headers })
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error.response?.data;
    });
}

//api call for registration
async function adminRegistration(registerData, companyId,workshop_id,is_project=false) {
  //call the api for registration

  const api = is_project ? url + `/companies/${companyId}/workshops/${workshop_id}/admins/register?is_project=${is_project}`
                         : url + `/companies/${companyId}/workshops/${workshop_id}/admins/register`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, registerData, { headers })
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error.response?.data;
    });
}

/**
 * Sends a request to reset the password .
 * @param {string} email - The email for which the password reset request is made.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function forgotPassword(email) {
  //api for verifying the email

  const api = url + `/reset-password`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, email, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false ,email varfication fails
      return error;
    });
}

/**
 * Verifies the token .
 * @param {string} token - The token to be verified.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function verifyToken(token,isfirst_time) {
  // api for verifying the token

  const tokenbaseURL = url + `/validate-reset-token`;
  const api = isfirst_time ? `${tokenbaseURL}?first_time=${isfirst_time}` : tokenbaseURL;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, { token: token }, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false ,token varfication fails
      return error;
    });
}

/**
 * Changes the password .
 * @param {object} data - The data for changing the password.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function changePassword(data) {
  //call the api for changing password

  const api = url + `/change-password`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, data, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false, password reset  fails
      return error;
    });
}
//api for admin login
async function login(loginData) {
  //call the api for login

  const api = url + `/login/otp/verify`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, loginData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}


//api for participant login
async function participantLogin(loginData) {
  //call the api for login

  const api = url + `/participants/login/otp/verify`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, loginData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}


async function participantForgotPassword(email) {
  //api for verifying the email

  const api = url + `/participants/reset-password`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, email, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false ,email varfication fails
      return error;
    });
}

/**
 * Verifies the token .
 * @param {string} token - The token to be verified.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function participantVerifyToken(token,isfirst_time) {
  // api for verifying the token
  const tokenbaseURL = `${url}/participants/validate-reset-token`;
  const api = isfirst_time ? `${tokenbaseURL}?first_time=${isfirst_time}` : tokenbaseURL;
 // const api = url + `/participants/validate-reset-token`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, { token: token }, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false ,token varfication fails
      return error;
    });
}

/**
 * Changes the password .
 * @param {object} data - The data for changing the password.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function participantChangePassword(data) {
  //call the api for changing password

  const api = url + `/participants/change-password`;
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios
    .post(api, data, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      //returns false, password reset  fails
      return error;
    });
}


/**
 * Verifies the token .
 * @param {string} otp_code - The otp to be verified.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function loginAndSendOTP(loginData) {
  //call the api for login using email ans paswd
  const api = url + `/login`;
  const headers = {
    "Content-Type": "application/json",
  };
  return await axios
    .post(api, loginData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      //returns false ,token varfication fails
      return error;
    });
}



/**
 * Changes the password .
 * @param {object} data - The data for changing the password.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function resendLoginOTP(data) {
  //call the api resend login OTP
  const api = url + `/login/otp/resend`;
  const headers = {
    "Content-Type": "application/json",
  };
  return await axios
    .post(api, data, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      return error;
    });
}

/**
 * Verifies the token .
 * @param {string} otp_code - The otp to be verified.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function participantsloginAndSendOTP(loginData) {
  //call the api for login using email and password

  const api = url + `/participants/login`;
  const headers = {
    "Content-Type": "application/json",
  };
  return await axios
    .post(api, loginData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}



/**
 * Changes the password .
 * @param {object} data - The data for changing the password.
 * @returns {Promise<number|Error>} - A promise that resolves with a status code (1 for success) or an error object.
 */
async function participantsResendLoginOTP(data) {
  //call the api for resend login otp
  const api = url + `/participants/login/otp/resend`;
  const headers = {
    "Content-Type": "application/json",
  };
  return await axios
    .post(api, data, { headers })
    .then(() => {
      //returns true if status is 200
      return 1;
    })
    .catch((error) => {
      return error;
    });
}